var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m19 17-1 1.094c-.53.58-1.25.906-2 .906a2.7 2.7 0 0 1-2-.906 2.72 2.72 0 0 0-2-.904c-.75 0-1.469.325-2 .904M1 19h1.675c.489 0 .733 0 .963-.055q.309-.075.579-.24c.201-.123.374-.296.72-.642L17.5 5.5a2.121 2.121 0 1 0-3-3L1.937 15.063c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579c-.055.23-.055.474-.055.964z"
  })));
};
export default SvgEdit;